export const ContractTypeIces = ['更优价格', '更快成交', '盘口排队']
